import { memo } from "react";
import type { IconProps } from "types";

const ActionArrowLeft = ({width = "16", height = "16"}: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2 8H14M2 8L5.99999 12M2 8L5.99999 4"
            stroke="#141516"
            strokeWidth="1.37931"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default memo(ActionArrowLeft);
